// import React, { useState, useRef, useEffect } from 'react';
// import { Bar } from 'react-chartjs-2';
// import { Dropdown } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     PointElement,
//     LineElement,
//     LineController,
//     BarController,
// } from 'chart.js';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     PointElement,
//     LineElement,
//     LineController,
//     BarController
// );

// const options = {
//     responsive: true,
//     plugins: {
//         legend: {
//             position: 'top',
//         },
//         tooltip: {
//             mode: 'index',
//             intersect: false,
//         },
//     },
//     scales: {
//         x: {
//             stacked: false, // Change this to false
//         },
//         y: {
//             stacked: false, // Change this to false
//             beginAtZero: true,
//         },
//     },
// };

// const data = {
//     labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     datasets: [
//         {
//             type: 'bar',
//             label: 'Pending',
//             data: [15, 18, 13, 22, 20, 25, 21, 22, 20, 15, 18, 22],
//             backgroundColor: 'rgba(240, 207, 43, 1)', // Yellow
//             borderColor: 'rgba(240, 207, 43, 1)',
//             borderWidth: 1,
//             borderRadius: 4,
//             barThickness: 8,
//             borderSkipped: false,
//         },
//         {
//             type: 'bar',
//             label: 'Rejected',
//             data: [5, 10, 5, 10, 5, 10, 5, 10, 5, 10, 5, 10],
//             backgroundColor: 'rgba(255, 94, 94, 1)', // Red
//             borderColor: 'rgba(255, 94, 94, 1)',
//             borderWidth: 1,
//             borderRadius: 4,
//             barThickness: 8,
//             borderSkipped: false,
//         },
//         {
//             type: 'line',
//             label: 'Approved',
//             data: [10, 12, 18, 15, 14, 15, 18, 16, 18, 14, 16, 17],
//             backgroundColor: function (context) {
//                 const chart = context.chart;
//                 const ctx = chart.ctx;
//                 const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
//                 gradient.addColorStop(0, 'rgba(58, 201, 119, 0.2)');
//                 gradient.addColorStop(1, 'rgba(58, 201, 119, 0)');
//                 return gradient;
//             },
//             borderColor: 'rgba(58, 201, 119, 1)',
//             borderWidth: 2,
//             fill: true,
//             tension: 0.4,
//         },
//     ],
// };

// const AttendanceStatusChart = () => {
//     const [selectedUser, setSelectedUser] = useState('User Name');
//     const [selectedCompany, setSelectedCompany] = useState('Company Name');
//     const [selectedMonth, setSelectedMonth] = useState('Month');
//     const [selectedYear, setSelectedYear] = useState('Year');

//     const handleSelectUser = (eventKey) => setSelectedUser(eventKey);
//     const handleSelectCompany = (eventKey) => setSelectedCompany(eventKey);
//     const handleSelectMonth = (eventKey) => setSelectedMonth(eventKey);
//     const handleSelectYear = (eventKey) => setSelectedYear(eventKey);

//     const chartRef = useRef(null);

//     useEffect(() => {
//         if (chartRef.current) {
//             const chart = chartRef.current.chartInstance;
//             // Additional chart customization can be done here if needed
//         }
//     }, []);

//     return (
//         <div className="barchart-container">
//             <div className="attendance-status-container mb-3">
//                 <h6>Status</h6>
//                 <div className="d-flex">
//                     <Dropdown onSelect={handleSelectUser} className="me-2">
//                         <Dropdown.Toggle id="dropdown-user">
//                             {selectedUser}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             <Dropdown.Item eventKey="User Name">User Name</Dropdown.Item>
//                             <Dropdown.Item eventKey="Other User">Other User</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown onSelect={handleSelectCompany} className="me-2">
//                         <Dropdown.Toggle id="dropdown-company">
//                             {selectedCompany}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             <Dropdown.Item eventKey="Company Name">Company Name</Dropdown.Item>
//                             <Dropdown.Item eventKey="Other Company">Other Company</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown onSelect={handleSelectMonth} className="me-2">
//                         <Dropdown.Toggle id="dropdown-month">
//                             {selectedMonth}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             <Dropdown.Item eventKey="Month">Month</Dropdown.Item>
//                             <Dropdown.Item eventKey="January">January</Dropdown.Item>
//                             <Dropdown.Item eventKey="February">February</Dropdown.Item>
//                             {/* Add other months here */}
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown onSelect={handleSelectYear}>
//                         <Dropdown.Toggle id="dropdown-year">
//                             {selectedYear}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             <Dropdown.Item eventKey="2023">2023</Dropdown.Item>
//                             <Dropdown.Item eventKey="2024">2024</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                 </div>
//             </div>
//             <Bar ref={chartRef} data={data} options={options} />
//         </div>
//     );
// };

// export default AttendanceStatusChart;




import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    LineController,
    BarController,
} from 'chart.js';
import * as ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import jsPDF from 'jspdf';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, HeadingLevel, ImageRun } from "docx";
import html2canvas from 'html2canvas';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    LineController,
    BarController
);

const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false, // Allow chart to resize with container
    plugins: {
        legend: {
            position: 'top',
        },
        tooltip: {
            mode: 'index',
            intersect: false,
        },
    },
    scales: {
        x: {
            stacked: false,
            grid: {
                display: false, // Hide grid lines if needed
            },
        },
        y: {
            stacked: false,
            beginAtZero: true,
            grid: {
                display: true,
                borderColor: 'rgba(246, 246, 246, 1)',
                borderWidth: 0.5,
            },
        },
    },
};

const AttendanceStatusChart = forwardRef(
    ({
        moduleName,
        labels,
        datasets,
        chartOptions = {},
        dropdownOptions = {},
        defaultSelection = {},
        selectedOption,
        handleSelect
    }, ref) => {
        const chartRef = useRef(null);
        // Expose methods to parent component using useImperativeHandle
        useImperativeHandle(ref, () => ({
            handleDownloadExcel: async () => {
                // Capture chart image as base64
                const chartImage = chartRef.current.toBase64Image();

                // Create Excel workbook
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Attendance Status');

                // Add header row
                worksheet.columns = [
                    { header: 'Status', key: 'status', width: 20 },
                    ...labels.map(label => ({ header: label, key: label, width: 15 }))
                ];

                // Add data rows
                datasets.forEach(dataset => {
                    const row = {
                        status: dataset.label,
                        ...labels.reduce((acc, label, index) => {
                            acc[label] = dataset.data[index];
                            return acc;
                        }, {})
                    };
                    worksheet.addRow(row);
                });

                // Add chart image to worksheet
                const imageId = workbook.addImage({
                    base64: chartImage,
                    extension: 'png',
                });

                // Add image to worksheet (position the image where you want)
                worksheet.addImage(imageId, {
                    tl: { col: 0, row: datasets.length + 3 }, // Top-left position
                    ext: { width: 600, height: 400 }, // Image size
                });

                // Write the file to the browser
                const buffer = await workbook.xlsx.writeBuffer();
                const excelFile = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(excelFile, `${moduleName}_Attendance_Status.xlsx`);
            },
            handleDownloadPDF: () => {
                const chartImage = chartRef.current.toBase64Image();

                // Format the chart data (you can adjust this as per your specific use case)
                const chartDataFormatted = datasets.map(dataset => ({
                    status: dataset.label,
                    ...labels.reduce((acc, label, index) => {
                        acc[label] = dataset.data[index];
                        return acc;
                    }, {}),
                }));

                // Create a new PDF document
                const doc = new jsPDF();

                // Add chart image to PDF
                const imageWidth = 180; // Width of the image in the PDF
                const imageHeight = 100; // Height of the image in the PDF
                doc.addImage(chartImage, 'PNG', 15, 10, imageWidth, imageHeight);

                // Add some space between the chart and the table
                let startY = 120;

                // Define columns for the table
                const columns = [
                    { header: 'Status', dataKey: 'status' },
                    ...labels.map(label => ({ header: label, dataKey: label })),
                ];

                // Add table data to PDF using `jspdf-autotable`
                doc.autoTable({
                    head: [columns.map(col => col.header)], // Header row
                    body: chartDataFormatted.map(item => Object.values(item)), // Table data
                    startY: startY, // Start position below the chart
                    theme: 'grid', // Grid theme for better styling
                    styles: {
                        fontSize: 10,
                        cellPadding: 2,
                    },
                    headStyles: {
                        fillColor: [0, 122, 204], // Blue header background
                        textColor: [255, 255, 255], // White header text
                    },
                });

                // Save the PDF
                doc.save(`${moduleName}_Attendance_Status.pdf`);
            },
            handleDownloadWord: () => {
                const chartImage = chartRef.current.toBase64Image();

                // Format the chart data for Word document
                const chartDataFormatted = datasets.map(dataset => ({
                    status: dataset.label,
                    ...labels.reduce((acc, label, index) => {
                        acc[label] = dataset.data[index];
                        return acc;
                    }, {}),
                }));

                // Convert the chart image to a byte array for embedding in the Word document
                const base64Data = chartImage.split(',')[1];
                const byteArray = new Uint8Array(
                    atob(base64Data)
                        .split('')
                        .map((char) => char.charCodeAt(0))
                );

                // Create table rows dynamically based on the formatted data
                const tableRows = chartDataFormatted.map((data) => {
                    return new TableRow({
                        children: [
                            new TableCell({
                                children: [new Paragraph(data.status)],
                            }),
                            ...labels.map(label => new TableCell({
                                children: [new Paragraph(data[label].toString())],
                            })),
                        ],
                    });
                });

                // Set up the Word document structure
                const doc = new Document({
                    sections: [
                        {
                            children: [
                                // Title
                                new Paragraph({
                                    text: `${moduleName} Chart`,
                                    heading: HeadingLevel.TITLE,
                                }),

                                // Table with dynamic rows
                                new Table({
                                    rows: [
                                        new TableRow({
                                            children: [
                                                new TableCell({
                                                    children: [new Paragraph('Status')],
                                                    shading: { fill: 'CCCCCC' },
                                                }),
                                                ...labels.map(label => new TableCell({
                                                    children: [new Paragraph(label)],
                                                    shading: { fill: 'CCCCCC' },
                                                }))
                                            ],
                                        }),
                                        ...tableRows,
                                    ],
                                }),

                                // Chart Section
                                new Paragraph({
                                    text: 'Chart:',
                                    spacing: { before: 400, after: 200 },
                                }),
                                new Paragraph({
                                    children: [
                                        new ImageRun({
                                            data: byteArray,
                                            transformation: {
                                                width: 500,
                                                height: 300,
                                            },
                                        }),
                                    ],
                                }),
                            ],
                        },
                    ],
                });

                // Generate and download the Word file
                Packer.toBlob(doc)
                    .then((blob) => {
                        saveAs(blob, `${moduleName}_Details_Chart.docx`);
                    })
                    .catch((error) => {
                        console.error('Error generating Word document:', error);
                    });
            },
            handlePrint: () => {
                const chartImage = chartRef.current.toBase64Image();

                // Format the chart data for print
                const chartDataFormatted = datasets.map(dataset => ({
                    status: dataset.label,
                    ...labels.reduce((acc, label, index) => {
                        acc[label] = dataset.data[index];
                        return acc;
                    }, {}),
                }));

                // Generate printable HTML structure
                const printableContent = `
                    <html>
                        <head>
                            <title>Print Chart</title>
                            <style>
                                body {
                                    font-family: Arial, sans-serif;
                                    margin: 20px;
                                }
                                h1 {
                                    text-align: center;
                                }
                                table {
                                    width: 100%;
                                    border-collapse: collapse;
                                    margin-top: 20px;
                                }
                                th, td {
                                    border: 1px solid #ccc;
                                    padding: 8px;
                                    text-align: center;
                                }
                                th {
                                    background-color: #f4f4f4;
                                }
                                img {
                                    display: block;
                                    margin: 20px auto;
                                    max-width: 100%;
                                }
                            </style>
                        </head>
                        <body>
                            <h1>${moduleName} Chart</h1>
                            <img src="${chartImage}" alt="Chart Image" />
                            <table>
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        ${labels.map(label => `<th>${label}</th>`).join('')}
                                    </tr>
                                </thead>
                                <tbody>
                                    ${chartDataFormatted
                        .map(data =>
                            `<tr>
                                                <td>${data.status}</td>
                                                ${labels.map(label => `<td>${data[label]}</td>`).join('')}
                                            </tr>`
                        )
                        .join('')}
                                </tbody>
                            </table>
                            <script>
                                window.onload = function() {
                                    window.print();
                                }
                            </script>
                        </body>
                    </html>
                `;

                // Open the printable content in a new window
                const printWindow = window.open("", "_blank");
                if (printWindow) {
                    printWindow.document.open();
                    printWindow.document.write(printableContent);
                    printWindow.document.close();
                } else {
                    console.error("Failed to open print window.");
                }
            },
            handleDownloadImage: () => {
                const chartImage = chartRef.current.toBase64Image();

                // Format the data for download (similar to your example)
                const chartDataFormatted = datasets.map(dataset => ({
                    status: dataset.label,
                    ...labels.reduce((acc, label, index) => {
                        acc[label] = dataset.data[index];
                        return acc;
                    }, {}),
                }));

                // Create the HTML structure with the chart image and table
                const printableContent = `
                    <div style="font-family: Arial, sans-serif; margin: 20px;">
                        <h1 style="text-align: center;">${moduleName} Chart</h1>
                        <img src="${chartImage}" alt="Chart Image" id="chartImage" style="display: block; margin: 20px auto; max-width: 100%;" />
                        <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
                            <thead>
                                <tr>
                                    <th style="border: 1px solid #ccc; padding: 8px; text-align: center;">Status</th>
                                    ${labels.map(label => `<th style="border: 1px solid #ccc; padding: 8px; text-align: center;">${label}</th>`).join('')}
                                </tr>
                            </thead>
                            <tbody>
                                ${chartDataFormatted
                        .map(data =>
                            `<tr>
                            <td style="border: 1px solid #ccc; padding: 8px; text-align: center;">${data.status}</td>
                            ${labels.map(label => `<td style="border: 1px solid #ccc; padding: 8px; text-align: center;">${data[label]}</td>`).join('')}
                        </tr>`
                        )
                        .join('')}
                            </tbody>
                        </table>
                    </div>
                `;

                // Create a hidden container to hold the content for capturing
                const container = document.createElement('div');
                container.style.position = 'absolute';
                container.style.left = '-9999px'; // Hide the container
                container.innerHTML = printableContent;
                document.body.appendChild(container);

                // Use html2canvas to capture the content as an image
                html2canvas(container).then((canvas) => {
                    // Convert the canvas to an image
                    const imageData = canvas.toDataURL("image/png");

                    // Create a link to download the image
                    const link = document.createElement("a");
                    link.href = imageData;
                    link.download = `${moduleName}_Chart.png`;
                    link.click();

                    // Clean up: Remove the hidden container after download
                    document.body.removeChild(container);
                }).catch((error) => {
                    console.error("Error capturing the image:", error);
                });
            },
        }));

        return (
            <div className="barchart-container">
                <div className="attendance-status-container">
                    <h6>{moduleName}</h6>
                    <div className="d-flex">
                        {Object.keys(dropdownOptions).map((key) => (
                            <Dropdown
                                key={key}
                                onSelect={(eventKey) => handleSelect(eventKey, key)}
                                className="me-2"
                            >
                                {/* <Dropdown.Toggle id={`dropdown-${key}`}>
                                {key === 'company' 
                                    ? selectedOption?.company?.name || dropdownOptions[key].default 
                                    : selectedOption[key] || dropdownOptions[key].default
                                }
                            </Dropdown.Toggle> */}
                                <Dropdown.Toggle id={`dropdown-${key}`}>
                                    {key === 'company'
                                        ? selectedOption?.company?.name || dropdownOptions[key].default
                                        : selectedOption?.[key] || dropdownOptions[key].default
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {dropdownOptions[key].items.map((item) => (
                                        <Dropdown.Item key={item.value} eventKey={item.value}>
                                            {item.label}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        ))}
                    </div>
                </div>
                <div className="barchart-canvas-container">
                    <Bar
                        data={{ labels, datasets }}
                        options={{ ...defaultOptions, ...chartOptions }}
                        ref={chartRef}
                    />
                </div>
            </div>
        );
    });

export default AttendanceStatusChart;
